import Api from "../Api";

class NewsletterService {
    async suscribe(data) {
        try {
            return await Api().post('testimonial/mailchimp/newsletter', data);
        } catch (error) {
            if (error.response.status === 500 || error.response.status === 400) {
                throw new Error("Echec! Une erreur est survenue lors de la souscription à la newsletter")
            }
        }
    }
}

export const newsletterService = new NewsletterService();